<h1 class="head1">Prikbord</h1>
<ng-container *ngIf="vm$ | async as vm">
  <div class="prikbord__content">
    <div class="informatief__col">
      <h2 class="head2">Informatief</h2>
      <ul class="informatief__panel">
        <li *ngFor="let item of vm.informatief trackBy:getPrikbordItemId" class="informatief-row">
          <a href="#" (click)="showPrikbordDetail(item)" class="titel c2-clickable">{{item.Titel}}</a>
          <span class="datum">{{item.DatumUpdate | date}}</span>
        </li>
      </ul>
    </div>
    <div class="externelinken_col">
      <h2 class="head2">Externe linken</h2>
      <ul class="externelinken__panel">
        <li *ngFor="let item of vm.extern;trackBy:getPrikbordItemId" class="extern-row">
          <a href="#" class="titel c2-clickable" (click)="openExterneUrl(item)">{{item.Titel}}</a>
          <span class="datum2">{{item.DatumUpdate | date}}</span>
          <i class="icon-external-link"></i>
        </li>
      </ul>
    </div>
  </div>

  <div class="dialog" role="dialog" aria-labelledby="prikbord-detail-titel" *ngIf="vm.currentItem">

    <div class="dialog-title">
      <h1 id="prikbord-detail-titel" class="head2">{{vm.currentItem.Titel}}</h1>
      <a href="#" role="button" aria-label="Sluit bijlage" (click)="closeDetail()" class="btn-icon icon-close"></a>
    </div>

    <div class="dialog-content">
      {{vm.currentItem.Content}}
    </div>

    <div class="dialog-bijlage" *ngIf="vm.currentItem.HasBijlage">
      {{vm.currentItem.BijlageTitel}}
      <app-document-viewer *ngIf="vm.documentdata" [documentdata]="vm.documentdata"></app-document-viewer>
    </div>

  </div>
  <ng-container>